<template>
    <div
        class="solid-logo"
        :class="{
            offset: offset,
            'solid-logo-responsive': placement === 'checkout',
        }">
        <LazyImage
            src="https://cdn.sanity.io/images/inntox6v/production/4e897ab0adefcac979a9ad32959bce64bc48ab5b-800x298.png"
            :alt="t({ key: 'aria.solid_logo' })" />
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import LazyImage from '@ui/components/LazyImage/LazyImage.vue';

    export default defineComponent({
        name: 'SolidLogo',
        methods: { t },
        components: { LazyImage },
        props: {
            offset: {
                type: Boolean,
                default: false,
            },
            placement: {
                type: String as () => 'checkout' | 'booking',
                required: true,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'SolidLogo';
</style>
